import { createFileRoute } from "@tanstack/react-router";
import { useApiDocsPresenter } from "@/app/useApiDocsPresenter";

const ApiDocsRedirect: React.FunctionComponent = () => {
  useApiDocsPresenter();

  return null;
};

export const Route = createFileRoute("/api-docs")({
  component: ApiDocsRedirect,
});
